import { Checkbox, Select, Spin, Switch, Tabs, TabsProps, Tooltip } from "antd";

import React, { memo, useCallback, useEffect, useState } from "react";
import NewTabContent from "../../components/EngageTranslationComponent/TabContent/NewTabContent";
import QualityControlContent from "../../components/EngageTranslationComponent/TabContent/QualityControlContent";
import ClientReadyContent from "../../components/EngageTranslationComponent/TabContent/ClientReadyContent";
import { ReactNode } from "react";
import { SyncOutlined } from "@ant-design/icons";
import "./EngageTranslatePage.css";
import Search from "antd/es/input/Search";
import FileUploadModal from "../../components/EngageTranslationComponent/Modal/FileUploadModal/FileUploadModal";
import { FontIcon } from "@fluentui/react";
import "./EngageTranslatePage.css";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { autoRefresh, closeDocumentInfoModal, closeQuickUploadTranslationDocument, closeUploadFileProgress, closeUploadTranslationDocument, fetchDocuments, fetchSearchTabs, getDocumentPresigned, multiDownloadDocuments, openDocumentInfoModal, openQuickUploadTranslationDocument, openUploadFileProgress, openUploadTranslationDocument, resetTabState, searchDocuments, setCustomFont, stopAutoRefresh, switchAutoFresh, updateRequestBody, updateTab } from "../../redux/EngageTranslation/EngageTranslationAction";
import FileUploadProgressContainer from "../../components/EngageTranslationComponent/FileUploadComponent/FileUploadProgressContainer";
import ErrorPage from "../template/ErrorPage/ErrorPage";
import LoadingPage from "../template/LoadingPage/LoadingPage";
import ArchivedContent from "../../components/EngageTranslationComponent/TabContent/ArchivedContent";
import DocumentInfoModal from "../../components/EngageTranslationComponent/Modal/DocumentInfoModal/DocumentInfoModal";
import AutoRefreshCheckbox from "../../components/EngageTranslationComponent/AutoRefreshCheckbox";
import TabPane from "antd/es/tabs/TabPane";
import { getSessionData } from "../../services/auth/AuthAPI";
import AccessDenied from "../../components/Template/AccessDenied/AccessDenied";
import AllContent from "../../components/EngageTranslationComponent/TabContent/AllContent";
import PSPDFKit from "pspdfkit";
import UploadButton from "../../components/Template/Btns/UploadButton/UploadButton";
import QuickUploadModal from "../../components/EngageTranslationComponent/Modal/QuickUploadModal/QuickUploadModal";

function EngageTranslationPage(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [searchValue, setSearchValue] = useState("");
  const [downloadFontLoading, setDownloadFontLoading] = useState<boolean>(false);
  const engageTranslationMainState = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState);
  const AllRecordsCount = useSelector((state: RootState) => state.engageTranslationState.allTabState.count);
  const documentInfoModalStatus = useSelector((state: RootState) => state.engageTranslationState.qualityControlState.modal.modalStatus);
  const tabsArray = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.tabsArray);
  const tabsLoading = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.tabsLoading);
  const IsQcLoggedIn = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.IsQcLoggedIn);
  const customFontState = useSelector((state: RootState) => state.engageTranslationState.customFonts);
  const dispatch = useAppDispatch();

  const fetcher = (fontFileName: string) =>
    fetch(`/dynamicFonts/${fontFileName}`, {
      // Adding Get request
      // Setting response type to arraybuffer
      // Setting response type to arraybuffer
    }).then(async (r) => {
      if (r.ok) {
        return r.blob();
      } else {
        throw new Error();
      }
    });

  useEffect(() => {
    dispatch(fetchSearchTabs());

    return () => {
      dispatch(stopAutoRefresh());
      if (tabsArray.length > 0) {
        dispatch(resetTabState(searchParams.get("view") || tabsArray[0].internalName));
      }
    };
  }, []);

  useEffect(() => {
    if (customFontState === null) {
      const customFonts = ["NotoSansSC-Regular.otf", "NotoSansSC-Bold.otf", "NotoSansJP-Bold.otf", "NotoSansJP-Regular.otf", "NotoSansKR-Regular.otf", "NotoSansKR-Bold.otf", "NotoSansTC-Bold.otf", "NotoSansTC-Regular.otf"].map((font) => {
        const pspdfFont = new PSPDFKit.Font({
          name: font,
          callback: fetcher,
        });
        return pspdfFont;
      });
      dispatch(setCustomFont(customFonts));
    }

    return () => {
      setDownloadFontLoading(false);
    };
  }, []);

  useEffect(() => {
    if (tabsArray.length > 0) {
      dispatch(fetchDocuments({ view: searchParams.get("view") || tabsArray[0].internalName }));
      dispatch(updateTab(searchParams.get("view") || tabsArray[0].internalName));
    }
  }, [tabsLoading]);

  useEffect(() => {
    setSearchValue("");
  }, [searchParams.get("view")]);

  const tabChildren = {
    new: <NewTabContent />,
    "quality-control": <QualityControlContent />,
    "client-ready": <ClientReadyContent />,
    archived: <ArchivedContent />,
    all: <AllContent />,
  };
  const { Option } = Select;

  const selectBefore = (
    <Select
      // defaultValue="All Items"
      onChange={(value) => {
        dispatch(resetTabState(value));
        dispatch(updateTab(value));
        navigate(`?view=${value}`);
        dispatch(fetchDocuments({ view: value }));
        dispatch(autoRefresh({ view: value }));
      }}
      style={{ width: 140 }}
      options={[...engageTranslationMainState.tabViews.map((item) => ({ value: item.key, ...item })), { label: "All Items", value: "all" }]}
      value={searchParams.get("view") || "new" || engageTranslationMainState.tab}
    />
  );
  const tabItems: TabsProps["items"] = [
    ...engageTranslationMainState.tabViews.map((item) => {
      return {
        key: item.key,
        label: <b>{item.label + ` (${item.count})`}</b>,
        children: tabChildren[item.key],
      };
    }),
  ];

  searchParams.get("view") === "all" && tabItems.push({ key: "all", label: <b>All Items ({AllRecordsCount})</b>, children: tabChildren["all"] });

  const ActionExtraContent = useCallback(() => {
    switch (searchParams.get("view")) {
      case "new": {
        return (
          <div className="d-flex gap-3 px-2 action-btn-container align-items-center">
            <AutoRefreshCheckbox view="new" />

            <UploadButton />

            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }

      case "quality-control": {
        return (
          <div className="d-flex gap-3 px-2  action-btn-container">
            <AutoRefreshCheckbox view="quality-control" />

            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }
      case "client-ready": {
        return (
          <div className="d-flex gap-3 px-2  action-btn-container">
            <AutoRefreshCheckbox view="client-ready" />
            <button
              className="button tab"
              onClick={() => dispatch(multiDownloadDocuments())}>
              Download
            </button>
            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }
      case "archived": {
        return (
          <div className="d-flex gap-3 px-2 action-btn-container">
            <AutoRefreshCheckbox view="archived" />

            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }
      case "all": {
        return (
          <div className="d-flex gap-3 px-2 action-btn-container">
            <AutoRefreshCheckbox view="all" />

            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }
      case null: {
        return (
          <div className="d-flex gap-3 px-2 action-btn-container ">
            <AutoRefreshCheckbox view="new" />

            {!IsQcLoggedIn && <UploadButton />}

            {engageTranslationMainState.isUploading && (
              <button
                className="upload-progress-container"
                onClick={() => dispatch(openUploadFileProgress())}>
                <SyncOutlined
                  style={{ fontSize: 15 }}
                  spin
                />
                Uploading {engageTranslationMainState.fileUploadCount} File
              </button>
            )}
          </div>
        );
      }
      default: {
        return <div className="d-flex gap-3 px-2 ">{!IsQcLoggedIn && <UploadButton />}</div>;
      }
    }
  }, [engageTranslationMainState.isUploading, searchParams.get("view"), IsQcLoggedIn]);

  const onSearch = (value: string) => {
    dispatch(
      searchDocuments({
        view: searchParams.get("view") || tabsArray[0].internalName,
        searchKeyword: value,
      })
    );
  };

  if ((engageTranslationMainState.documentAPIState.loading && engageTranslationMainState.tabViews.length === 0) || tabsLoading || downloadFontLoading) {
    return <LoadingPage />;
  }

  if (engageTranslationMainState.documentAPIState.error) {
    console.log(engageTranslationMainState.documentAPIState.error);
    return (
      <ErrorPage
        errorDescription="An error is encountered while processing your request. Please retry again."
        actionBtn={
          <button
            className="button"
            onClick={() => window.location.reload()}>
            Try again
          </button>
        }
      />
    );
  }

  return (
    <div className="body-container gap-3 overflow-hidden">
      <FileUploadModal
        open={() => dispatch(openUploadTranslationDocument())}
        close={() => dispatch(closeUploadTranslationDocument())}
        openState={engageTranslationMainState.uploadTranslationDocumentOpenSate}
      />

      <QuickUploadModal
        open={() => dispatch(openQuickUploadTranslationDocument())}
        close={() => dispatch(closeQuickUploadTranslationDocument())}
        openState={engageTranslationMainState.quickUploadTranslationDocumentOpenSate}
      />

      <div className="d-flex full-flex overflow-hidden w-100">
        <div className="h-100 position-relative overflow-hidden pt-3 w-100">
          {searchParams.get("view") === "new" && IsQcLoggedIn ? (
            <AccessDenied />
          ) : (
            <Tabs
              type="card"
              items={tabItems}
              activeKey={searchParams.get("view") || engageTranslationMainState.tab}
              size="large"
              tabBarExtraContent={{
                right: <ActionExtraContent />,
              }}
              renderTabBar={(props: TabsProps, DefaultTabBar: any) => (
                <div className="tab-bar-container ">
                  <div className="d-flex gap-1 pe-4 h-100">
                    {tabItems.map((item) => {
                      return (
                        <div
                          className={`tab-btn ${item.key === engageTranslationMainState.tab ? "active" : ""}`}
                          onClick={() => {
                            console.log(tabItems);
                            console.log(item.key);
                            dispatch(resetTabState(engageTranslationMainState.tab));
                            dispatch(updateTab(item.key));
                            navigate(`?view=${item.key}`);
                            dispatch(fetchDocuments({ view: item.key }));
                            dispatch(autoRefresh({ view: item.key }));
                          }}>
                          {item.label}
                        </div>
                      );
                    })}
                  </div>
                  <div className="search-bar">
                    <Search
                      type="text"
                      size="large"
                      value={searchValue}
                      onSearch={(value) => onSearch(value.trimEnd().trimStart())}
                      allowClear
                      addonBefore={selectBefore}
                      placeholder="Search..."
                      onChange={(e) => setSearchValue(e.target.value)}
                      //style to make the content in the center horizontally of the parent position relative
                    />
                  </div>

                  <ActionExtraContent />
                </div>
              )}
              style={{ height: "100%", width: "100%" }}
            />
          )}
        </div>
        {engageTranslationMainState.uploadFileInProgressOpenState && <FileUploadProgressContainer close={() => dispatch(closeUploadFileProgress())} />}
        {
          <DocumentInfoModal
            openState={documentInfoModalStatus}
            close={() => dispatch(closeDocumentInfoModal())}
          />
        }
        {/* <FileUploadProgressContainer /> */}
      </div>
    </div>
  );
}

export default EngageTranslationPage;
